<app-si-dialog [header]="header" [isLoading]="isLoading$ | async" modalFooterClasses="si-dialog__footer--centered">
	<ng-template appDialogBody>
		<div class="gap-0 p-6">
			<div class="flex flex-col gap-7">
				<div class="flex flex-wrap -mx-2 si-form-row">
					<label class="flex-none w-1/3 px-2 self-center">
						Name:
					</label>
					<div class="flex-none w-2/3 px-2">
						<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="w-full">
							<mat-label>Name</mat-label>
							<input matInput [(ngModel)]="search.searchName">
						</mat-form-field>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2 si-form-row">
					<label class="flex-none w-1/3 px-2 self-center">
						Visibility:
					</label>
					<div class="flex-none w-2/3 px-2">
						<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="w-full">
							<mat-label>Visibility</mat-label>
							<mat-select [(ngModel)]="search.isPublic" (ngModelChange)="onIsPublicChange($event)" #siSelectRef="matSelect">
								<mat-option [value]="false">Private</mat-option>
								<mat-option [value]="true">Team</mat-option>
							</mat-select>
							<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
						</mat-form-field>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2 si-form-row">
					<label class="flex-none w-1/3 px-2 self-center">
						Default View:
					</label>
					<div class="flex-none w-2/3 px-2">
						<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="w-full">
							<mat-label>Default View</mat-label>
							<mat-select [(ngModel)]="search.type" #siSelectRef2="matSelect">
								<mat-option [value]="'contact'">Contact</mat-option>
								<mat-option [value]="'company'">Company</mat-option>
							</mat-select>
							<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
						</mat-form-field>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2 si-form-row">
					<label class="flex-none w-1/3 px-2 self-center">
						Tags (Optional):
					</label>
					<div class="flex-none w-2/3 px-2">
						<app-multi-selector-form-field
                        [items]="tagList$ | async"
                        bindLabel="name"
                        bindValue="id"
                        label="Tags"
                        placeholder="Tags"
                        [(ngModel)]="search.tags"
                        name="tags"
                        [isLoading]="(isCreateTagLoading$ | async)"
                        [showChipsList]="true"
                        ngDefaultControl
                        [listElementTooltipIfTruncated]="true"
                    >
                    <ng-template #preOption let-value="inputValue">
                        <span><a class="cp-dark-link" (click)="createTag(value)">{{value}} (Create New)</a></span>
                    </ng-template>
                </app-multi-selector-form-field>
					</div>
				</div>
			</div>

            <div *ngIf="featureFlagsEnum.IdealCustomerProfileAutomations | isFeatureFlagEnabled | async; else noICPAutomationsFlag">
                <div class="flex flex-wrap -mx-2 items-center mt-4">
                    <span class="flex-none w-1/3 mb-2 px-2">
                      <div [matTooltip]="isSavedSearchCountsExceedLimit ? 'This saved search is too large. Your saved search cannot exceed 2M companies or contacts. Please update your search or select a new one.' : ''">
                          <mat-checkbox
                            [(ngModel)]="isCreateAutomationEnabled"
                            [disabled]="isSavedSearchCountsExceedLimit"
                            labelPosition="before"
                          ><span class="mr-2">Create ICP Agent</span></mat-checkbox>
                      </div>
                    </span>

                </div>
                <div class="flex flex-wrap -mx-2">
                    <small class="flex-none w-full italic px-2">ICP Agents allow you to receive email alerts, or set up automatic exports, for any new companies and/or contacts that become available based on your saved search.</small>
			    </div>
            </div>

            <ng-template #noICPAutomationsFlag>
                <div class="flex flex-wrap -mx-2 items-center">
                    <label class="flex-none w-1/3 px-2 self-center">
                        Receive Email Alerts:
                    </label>
                    <div class="flex-none w-2/3 flex items-center px-2">
                        <mat-slide-toggle [(ngModel)]="search.sendEmailUpdates"></mat-slide-toggle>
                    </div>
                </div>
                <div class="flex flex-wrap -mx-2">
                    <small class="flex-none w-full italic px-2">Email alerts are available when contacts related to your search are updated. Company updates and searches with attached contact lists are not supported.</small>
                </div>
            </ng-template>

		</div>
	</ng-template>
	<ng-template appDialogFooter>
		<button matButton="outlined" type="button" (click)="onClose()">Cancel</button>
		<button matButton="filled" type="button" [disabled]="isLoading$ | async" (click)="onSaveSearch()">Save</button>
	</ng-template>
</app-si-dialog>

